import React from "react";

import {
  AccordionDetails,
  AccordionProps as MuAccordionProps,
  AccordionSummary,
  Avatar,
  Box,
  Chip,
  Typography,
  useTheme,
} from "@mui/material";
import MuAccordion from "@mui/material/Accordion";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export type AccordionProps = MuAccordionProps & {
  title?: string;
  titleElement?: React.ReactNode;
  backgroundColor?: string;
  chipColor?: string;
  showOpenChip?: boolean;
  titleFontSize?: string;
  width?: string;
  avatarText?: string;
  footer?: React.ReactNode;
  hideFooter?: boolean;
  unExpandable?: boolean;
};

function Accordion({
  footer,
  hideFooter = false,
  unExpandable = false,
  expanded = true,
  ...others
}: AccordionProps) {
  const theme = useTheme();

  return (
    <MuAccordion
      {...others}
      expanded={expanded}
      sx={{
        cursor: unExpandable ? "default" : "pointer",
        backgroundColor: others.backgroundColor
          ? others.backgroundColor
          : theme.palette.primary.lighter,
        width: others.width ? others.width : "auto",
        padding: "16px 16px 12px 16px",
        gap: "8px",
        borderRadius: "8px!important",
        boxShadow: "none",
        ":before": {
          display: "none",
        },
        ...others.sx,
      }}>
      <AccordionSummary
        expandIcon={!unExpandable && <ExpandMoreIcon />}
        sx={{ cursor: unExpandable ? "default!important" : "pointer" }}
        aria-controls="panel1bh-content"
        id="panel1bh-header">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}>
          {others.avatarText && (
            <Avatar
              sx={{
                width: "30px",
                height: "30px",
                fontSize: "14px",
                backgroundColor: "primary.main",
              }}>
              {others.avatarText}
            </Avatar>
          )}
          {others.titleElement}
          <Typography
            sx={{
              fontSize: others.titleFontSize ? others.titleFontSize : "20px",
              fontWeight: 600,
            }}
            component={"span"}>
            {others.title}
          </Typography>
        </Box>
        {expanded && others?.showOpenChip && (
          <Chip
            label="Opened"
            variant="filled"
            sx={{
              backgroundColor: others.chipColor ? others.chipColor : theme.palette.info[100],
              color: "white",
              ml: "auto",
              marginRight: "4px",
              maxHeight: "19px",
              padding: "2px 4px",
              "& .MuiChip-label": {
                letterSpacing: "-0.24px",
                fontSize: "12px !important",
                padding: 0,
              },
            }}
          />
        )}
      </AccordionSummary>
      {!unExpandable && others.children}
    </MuAccordion>
  );
}

Accordion.AccordionDetails = AccordionDetails;

export default Accordion;
